import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

// css
import styles from "../MyProfile.module.scss";

// img
import user from "../../../../../Assets/images/user.png";
import { toast } from "react-toastify";
import {
  GET_PROFILE_INFO,
  UPDATE_PROFILE,
} from "../../../../../services/ApiCalls";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import fileUploader from "../../../../../utilities/fileUploader";
import AddressInput from "../../../../../components/Common/address";

const schema = z.object({
  businessName: z
    .string()
    .trim()
    .min(1, { message: "Business name is required" }),
  firstName: z.string().trim().min(1, { message: "First name is required" }),
  lastName: z.string().trim().min(1, { message: "Last name is required" }),
  businessAddress: z
    .string()
    .trim()
    .min(1, { message: "Address name is required" }),
  email: z
    .string({
      required_error: "email is required",
    })
    .min(1, { message: "Email is required" })
    .email("Invalid email address"),
  // DriverPercentageComission: z
  //   .string()
  //   .trim()
  //   .min(1, { message: "Driver Commision is required" }),
  // DriverPercentageComission: z
  //   .preprocess((value) => Number(value), z.number())
  //   .min(1, { message: "Driver Commission is required" })
  //   .nonnegative({ message: "Driver Commission must be a positive number" }),
  DriverPercentageComission: z.preprocess(
    (value) => {
      // Convert the input value to a number
      const parsedValue = parseFloat(value);
      // If the conversion results in NaN, return undefined to trigger validation failure
      return isNaN(parsedValue) ? undefined : parsedValue;
    },
    z.number({ invalid_type_error: "Driver Commission must be a number" })
    // .gte(1, { message: "Driver Commission must be at least 1" })
  ),
});

const PersonalInfo = () => {
  const [uploadedImage, setUploadedImage] = useState();
  const [isJoinedMember, setIsJoinedMember] = useState(false);
  const [contactNumber, setContactNUmber] = useState({
    countryCode: "",
    mobileNumber: "",
  });
  const [Error, setError] = useState({
    contactNumber: "",
  });
  const [profileInfo, setProfileInfo] = useState();
  const [DriverPercentageComission, setDriverPercentageComission] = useState();
  const {
    register,
    handleSubmit,
    setValue,
    trigger,
    watch,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
    values: {
      firstName: profileInfo?.firstName || "",
      email: profileInfo?.email || "",
      lastName: profileInfo?.lastName || "",
      businessAddress: profileInfo?.businessAddress || "",
      businessName: profileInfo?.businessName || "",
      DriverPercentageComission: profileInfo?.DriverPercentageComission || "",
    },
  });

  const [cords,setCords] = useState(null);
  console.log("cords",cords)
  const getProfileInfo = async () => {
    try {
      const res = await GET_PROFILE_INFO();
      console.log(res, "chkres");
      if (res?.data?.status === "success") {
        setProfileInfo(res?.data?.data);
        setContactNUmber({
          countryCode: res?.data?.data?.countryCode,
          mobileNumber: res?.data?.data?.mobileNumber,
        });

        setIsJoinedMember(res?.data?.data?.joinMembership === "yes");
        setUploadedImage(res?.data?.data?.profileImage);
        setDriverPercentageComission(
          res?.data?.data?.DriverPercentageComission
        );
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.success("something went wrong");
    }
  };

  const submitHandler = async (data) => {
    if (
      !contactNumber.countryCode.trim() ||
      !contactNumber.mobileNumber.trim()
    ) {
      return setError((p) => ({
        ...p,
        contactNumber: "Phone Number is Required",
      }));
    } else {
      setError((p) => ({ ...p, contactNumber: "" }));
    }
    
    try {
      const res = await UPDATE_PROFILE({
        ...data,
        profileImage: uploadedImage,
        joinMembership: isJoinedMember ? "yes" : "no",
        ...contactNumber,
        ...DriverPercentageComission,
        providerLocation: cords
      });
      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  const profileUploader = async (e) => {
    const url = await fileUploader(e.target.files[0]);

    if (url) {
      setUploadedImage(url);
    }
  };

  useEffect(() => {
    getProfileInfo();
  }, []);

  return (
    <>
      <Form className="pt-lg-4" onSubmit={handleSubmit(submitHandler)}>
        <Row className="">
          <Col lg="12" className="my-2">
            <div
              className={`${styles.profileUpload} d-flex gap-10 align-items-start justify-content-center position-relative`}
            >
              <div className="left position-relative">
                <div
                  className={`${styles.imgWrp} imgWrp mb-3 mx-auto rounded-circle`}
                  style={{ background: "rgb(243, 243, 243)" }}
                >
                  <img
                    src={uploadedImage || user}
                    alt=""
                    className="img-fluid w-100 h-100 rounded-circle"
                  />
                </div>

                <label
                  className="d-inline-flex align-items-center justify-content-center commonBtn h-auto  text-white px-2   py-1 rounded"
                  type="button"
                  htmlFor="image"
                >
                  <input
                    type="file"
                    className="d-none"
                    id="image"
                    onChange={profileUploader}
                  />
                  Upload New
                </label>
              </div>
              <div className="right mt-4">
                <h6 className="m-0 fw-bold">
                  Hi,{" "}
                  {`${profileInfo?.firstName || "-"}  ${
                    profileInfo?.lastName || "-"
                  }`}
                </h6>
                <p className="m-0">{profileInfo?.email || "-"}</p>
              </div>
            </div>
          </Col>
          <Col lg="4" sm="6" className="my-2">
            <label
              htmlFor=""
              className="form-label fw-sbold text-dark m-0 pb-1"
            >
              First Name
            </label>
            <input
              type="text"
              className="form-control"
              {...register("firstName")}
            />
            {
              <p className="errorColor">
                {errors?.firstName && errors.firstName.message}
              </p>
            }
          </Col>
          <Col lg="4" sm="6" className="my-2">
            <label
              htmlFor=""
              className="form-label fw-sbold text-dark m-0 pb-1"
            >
              Last Name
            </label>
            <input
              type="text"
              className="form-control"
              {...register("lastName")}
            />
            {
              <p className="errorColor">
                {errors?.lastName && errors.lastName.message}
              </p>
            }
          </Col>
          <Col lg="4" sm="6" className="my-2">
            <label
              htmlFor=""
              className="form-label fw-sbold text-dark m-0 pb-1"
            >
              Mobile Number
            </label>
            <PhoneInput
              value={`${contactNumber.countryCode}Code, "+" + ${contactNumber.mobileNumber}`}
              onChange={(mobileNumber, { dialCode }) => {
                setContactNUmber((p) => ({
                  countryCode: `+${dialCode}`,
                  mobileNumber: mobileNumber.replace(dialCode, ""),
                }));
              }}
              country={"us"}
            />
            {
              <p className="errorColor">
                {Error?.contactNumber && Error.contactNumber}
              </p>
            }
          </Col>
          <Col lg="4" sm="6" className="my-2">
            <label
              htmlFor=""
              className="form-label fw-sbold text-dark m-0 pb-1"
            >
              Email ID
            </label>
            <input
              type="email"
              className="form-control"
              {...register("email")}
            />
            {
              <p className="errorColor">
                {errors?.email && errors.email.message}
              </p>
            }
          </Col>
          <Col lg="4" sm="6" className="my-2">
            <label
              htmlFor=""
              className="form-label fw-sbold text-dark m-0 pb-1"
            >
              Business Name
            </label>
            <input
              type="text"
              className="form-control"
              {...register("businessName")}
            />
            {
              <p className="errorColor">
                {errors?.businessName && errors.businessName.message}
              </p>
            }
          </Col>

          <Col lg="4" sm="6" className="my-2">
            <label
              htmlFor=""
              className="form-label fw-sbold text-dark m-0 pb-1"
            >
              Business Address
            </label>
            {/* <input
              type="text"
              className="form-control"
              {...register("businessAddress")}
            /> */}{" "}
            <AddressInput
              name="businessAddress"
              placeholder="Enter your Address"
              errorLabel="Address"
              required
              defaultValue=""
              setValue={(val) => setValue("businessAddress", val)}
              trigger={() => trigger("businessAddress")}
              value={watch("businessAddress")}
              setCords={setCords}
            />
            {
              <p className="errorColor">
                {errors?.businessAddress && errors.businessAddress.message}
              </p>
            }
          </Col>
          <Col lg="4" sm="6" className="my-2">
            <label
              htmlFor=""
              className="form-label fw-sbold text-dark m-0 pb-1"
            >
              Driver Commission
            </label>
            <div className="input-group">
              <span className="input-group-text">%</span>
              <input
                type="text"
                placeholder="0"
                className="form-control"
                {...register("DriverPercentageComission")}
              />
            </div>
            {errors?.DriverPercentageComission && (
              <p className="errorColor">
                {errors.DriverPercentageComission.message}
              </p>
            )}
          </Col>

          {/* <Col lg="4" sm="6" className="my-2 align-self-center">
            <div className="d-flex align-items-center gap-10">
              <label htmlFor="" className="form-label fw-sbold text-dark m-0">
                Joinded Membership
              </label>
              <div className="d-flex align-items-center">
                <input
                  type="radio"
                  className="form-check me-2"
                  checked={isJoinedMember}
                  onChange={() => setIsJoinedMember(true)}
                />
                <label
                  htmlFor=""
                  className="form-label fw-normal text-dark m-0 pb-1"
                >
                  Yes
                </label>
              </div>
              <div className="d-flex align-items-center">
                <input
                  type="radio"
                  className="form-check me-2"
                  checked={!isJoinedMember}
                  onChange={() => setIsJoinedMember(false)}
                />
                <label
                  htmlFor=""
                  className="form-label fw-normal text-dark m-0 pb-1"
                >
                  No
                </label>
              </div>
            </div>
          </Col> */}
        </Row>
        <Row className="justify-content-center">
          <Col sm="4" className="my-2">
            <div className="btnWrpper my-3">
              <Button
                className="d-flex w-100 align-items-center justify-content-center commonBtn"
                type="submit"
              >
                Save
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default PersonalInfo;
